/**
 * Formatage d'affichage - document 03, section 8.
 *
 * Ces fonctions ne servent QU'À afficher. Une valeur qui en sort ne doit jamais
 * revenir dans un calcul : c'est l'origine de l'écart de 5,5 XAF constaté en
 * recette. Le moteur travaille en pleine précision, l'arrondi est terminal.
 */

const EUR = new Intl.NumberFormat('fr-FR', {
  style: 'currency', currency: 'EUR',
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

const CFA = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

const TAUX = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

export const eur = (n) => EUR.format(Number.isFinite(n) ? n : 0);

export const cfa = (n, devise = 'XAF') =>
  `${CFA.format(Math.round(Number.isFinite(n) ? n : 0))} ${devise}`;

export const taux = (n) => TAUX.format(Number.isFinite(n) ? n : 0);

/** Pourcentage signé, pour le coût client. */
export const pourcent = (n) =>
  `${n >= 0 ? '' : '−'}${TAUX.format(Math.abs(Number.isFinite(n) ? n : 0))} %`;

/**
 * Découpe des frais opérateur en clair : « 2 transferts : 2 004 + 1 194 ».
 * Le détail est demandé explicitement par la spécification - c'est lui qui rend
 * un débit vérifiable face au relevé de l'opérateur.
 */
export const decoupe = (tranches, devise = 'XAF') => {
  if (!tranches?.length) return null;
  const pluriel = tranches.length > 1 ? 's' : '';
  return `${tranches.length} transfert${pluriel} : ${tranches.map((t) => CFA.format(t)).join(' + ')} ${devise}`;
};

/**
 * Phrase prête à envoyer au client.
 *
 * Aucun calcul : elle ne fait que formater un résultat déjà produit par le
 * moteur. Elle vit ici et non dans un écran parce que Coter et Historique la
 * produisent tous deux - deux formulations qui divergent, c'est un client qui
 * reçoit deux prix différents pour la même cotation.
 */
export function reponseClient(r, devise) {
  if (r.direction === 'out') {
    const total = r.feeMode === 'refacture' ? r.totalRegleEur : r.montantEnvoye;
    return `Pour ${eur(total)}, le destinataire reçoit ${cfa(r.netCfa, devise)}.`;
  }
  return `Pour ${cfa(r.montantCollecte, devise)}, le bénéficiaire reçoit ${eur(r.recuEur)}.`;
}

/**
 * Relecture d'une valeur saisie, séparateurs de milliers compris.
 *
 * Un `input[type=number]` refuse les séparateurs : la saisie reste « 1000000 »,
 * qui ne se lit qu'en comptant les zéros. C'est précisément là qu'un facteur
 * dix passe inaperçu - et un plafond opérateur faux d'un facteur dix change le
 * nombre de tranches, donc le prix annoncé.
 *
 * Rend `null` sous mille : « 4 XAF » sous un champ qui affiche déjà « 4 »
 * n'apprend rien et ajoute du bruit là où la lecture était déjà sûre.
 */
export function lisible(valeur, unite) {
  const n = Number(valeur);
  if (!Number.isFinite(n) || Math.abs(n) < 1000) return null;
  return unite === 'EUR' ? eur(n) : cfa(n, unite);
}
